// extracted by mini-css-extract-plugin
export default {"services":"Services_services__OeRr4","servicesBody":"Services_servicesBody__ualSm","servicesSlider":"Services_servicesSlider__1eb8B"};